var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ocs-data-loader',{attrs:{"data-loaded":_vm.dataLoaded,"data-load-error":_vm.dataLoadError,"data-not-found":_vm.dataNotFound},scopedSlots:_vm._u([{key:"not-found",fn:function(){return [_c('not-found')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }